import {InfoView} from '@fantasmagames/slot/src/modules/hud/info/InfoView';
import {IRecodeVAPI} from '@fantasmagames/slot/src/integration/RecodeIntegrator';
import Spine = PIXI.spine.Spine;

export class RecodeInfoView extends InfoView {
	protected _bankingButton: PIXI.Sprite;
	protected _vApi: IRecodeVAPI;

	public init(): void {
		super.init();
		this.hideBankingButton();

		this._clock.visible = false;
		this._vApi = (window as any).V.API;

		if (!this.device.isMobile && this._vApi.BonusBubble.bubbleEnabled()) {
			this.setupBonusBubbleHover();
		}

		if (this._vApi.Core.isBankingAvailable()) {
			this.setupBankingButton();
			this.setUpBankingButtonEvents();
		}
	}

	protected setupBonusBubbleHover(): void {
		this._balanceText.on('mouseover', this.showBonusBubble.bind(this));
		this._balanceText.on('mouseout', this.hideBonusBubble.bind(this));
		this._balanceText.interactive = true;
	}

	protected setupBankingButton(): void {
		this._bankingButton = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'BANKING.png'));
		this.spineUtils.replaceElementInSpine(this._spineLayout, 'BANKING_BUTTON', this._bankingButton);
		this._bankingButton.interactive = true;
		this._bankingButton.buttonMode = true;
	}

	protected setUpBankingButtonEvents(): void {
		this._bankingButton.on(this.device.isMobile ? 'touchstart' : 'mousedown', this.openBanking.bind(this));
	}

	protected openBanking(): void {
		this._vApi.Core.launchBanking();
	}

	protected hideBankingButton(): void {
		this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BANKING_BUTTON')].children[0].visible = false;
	}

	private showBonusBubble(): void {
		const worldtransform = this._balanceText.worldTransform;
		const position = this.fullscreenManager.canvasPositionToWindow({x: worldtransform.tx, y: worldtransform.ty});

		this._vApi.BonusBubble.onBubbleTrigger(true, {x: position.x, y: position.y});
	}

	private hideBonusBubble(): void {
		this._vApi.BonusBubble.onBubbleTrigger(false, null);
	}

	protected setupLayout(): void {
		super.setupLayout();

		if (!(window as any)._canHaveFantasmaStuff) {
			const slotIndex = (this._spineLayoutAnimation.container as Spine).skeleton.findSlotIndex('FANTASMA_LOGO');
			const container = (this._spineLayoutAnimation.container as Spine).slotContainers[slotIndex];
			container.removeChildren();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/recode/RecodeInfoView.ts